export enum EnumTopicType {
  Prompt = 'prompt',
  QuickAction = 'quick_action',
}

export enum EnumContexto {
  CarteiraClientes = 'carteira-clientes',
  CadastroClientes = 'cadastro-clientes',
  Pedidos = 'pedidos',
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface ITopicRaw {
  type: EnumTopicType;
  message: string;
  icon: string;
  quick_action_id?: string;
}

export interface ITopicsResponseRaw {
  topics: ITopicRaw[];
  totalItens: number;
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface ITopic {
  type: EnumTopicType;
  message: string;
  icon: string;
  quickActionId?: string;
}

export interface ITopicsResponse {
  topics: ITopic[];
  totalItens: number;
}

const toTopic = (raw: ITopicRaw): ITopic => ({
  type: raw.type,
  message: raw.message,
  icon: raw.icon,
  quickActionId: raw.quick_action_id
});

export const toTopicsResponse = (raw: ITopicsResponseRaw): ITopicsResponse => ({
  topics: raw.topics.map(toTopic),
  totalItens: raw.totalItens
});
